// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-ManagementPage-Obj2Tab-forms-ServSettingsForm-ServFuncsEditor-ServFuncsEditor-module__itemBox--uPFRb {
  display: flex;
  flex-direction: row;
  gap: 16px;
}
.src-pages-ManagementPage-Obj2Tab-forms-ServSettingsForm-ServFuncsEditor-ServFuncsEditor-module__itemContent--WhcAY {
  flex: 1;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  column-gap: 20px;
}
.src-pages-ManagementPage-Obj2Tab-forms-ServSettingsForm-ServFuncsEditor-ServFuncsEditor-module__funcName--mKNYc {
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ManagementPage/Obj2Tab/forms/ServSettingsForm/ServFuncsEditor/ServFuncsEditor.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;AACA;EACE,OAAA;EACA,aAAA;EACA,+BAAA;EACA,6BAAA;EACA,gBAAA;AACF;AACA;EACE,aAAA;EACA,mBAAA;AACF","sourcesContent":[".itemBox {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n}\n.itemContent {\n  flex: 1;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-template-rows: auto auto;\n  column-gap: 20px;\n}\n.funcName {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"itemBox": `src-pages-ManagementPage-Obj2Tab-forms-ServSettingsForm-ServFuncsEditor-ServFuncsEditor-module__itemBox--uPFRb`,
	"itemContent": `src-pages-ManagementPage-Obj2Tab-forms-ServSettingsForm-ServFuncsEditor-ServFuncsEditor-module__itemContent--WhcAY`,
	"funcName": `src-pages-ManagementPage-Obj2Tab-forms-ServSettingsForm-ServFuncsEditor-ServFuncsEditor-module__funcName--mKNYc`
};
export default ___CSS_LOADER_EXPORT___;
